var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"favoritemovie"},[_c('img',{attrs:{"src":_vm.imgUrlFilm,"alt":"","width":"110"}}),_c('h3',[_vm._v(_vm._s(_vm.title))]),_c('span',{on:{"click":_vm.deleteFilm}},[_vm._v("X")])])}
var staticRenderFns = []

export { render, staticRenderFns }